import React, { useEffect, useState } from 'react';
import {getPermission} from '../../../Conexiones/Conexion';
import ModalAgregarAlmacen from './ModalAgregarAlmacen';
import { BsPlus } from 'react-icons/bs';
import moment from "moment/moment";
import { useNavigate } from 'react-router';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { deleteApi, getApi, postApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import Loading from '../../../Utils/Loading';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';

function TablaEntrada() {
    const [entradas,setEntradas]=useState([]);
    const [tablaEntradas,setTablaEntradas]=useState([]);
    const [busqueda, setBusqueda] = useState("");
    const numObra=parseInt(sessionStorage.getItem("obra"));
    sessionStorage.removeItem("idCM");
    sessionStorage.removeItem("nomCM");
    const [nombreObra,setNombreObra] = useState ('');
    const navigate = useNavigate();
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const [isSaving, setSaving] = useState(false);
    const [isLoading,setIsLoading]=useState(false);

    useEffect (()=>{
        const getEntradas = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,24);
            if(permiso){
                const endpoint = 'entradas-ini/'+numObra;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setEntradas(res.data[0].entradas);
                        setTablaEntradas(res.data[0].entradas);
                        setNombreObra(res.data[0].obra);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getEntradas()
    },[idUsuario,navigate,numObra])

    const getEntradas = async () =>{
        const endpoint = 'entradas-ini/'+numObra;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setEntradas(res.data[0].entradas);
                setTablaEntradas(res.data[0].entradas);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaEntradas.filter((elemento)=> {
            if  (elemento.nombreMat.toString().toLowerCase().includes(texto.toLowerCase()) || 
            moment(elemento.fechaEntMat).format("DD-MM-YYYY").toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda;
        });
        setEntradas(resBusqueda);
    }

    const getColor = (numEstado) => {
        if (numEstado === 1) return '#BDEFFC';
        if (numEstado === 2) return '#FFFD95';
        if (numEstado === 3) return '#D5FFBE';
        return '';
    };

  
    const regresar = () => {
        //navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/Materiales');
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras');
    }

    const eliminar = (id) => {
        warningModal('¿QUIERES ELIMINAR EL REGISTRO SELECCIONADO?')
        .then(async (result)  => {
            if (result.isConfirmed) {
                const endpoint = 'eliminarEnt/'+id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="registro eliminado"){
                        getEntradas();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2);
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }

    /*AGREGAR MATERIALES INICIO*/
    const [bodega,setBodega]=useState('');
    const resIdCat =  parseInt(sessionStorage.getItem("idCM"));
    const resNomCat =  sessionStorage.getItem("nomCM");
    const [categorias, setCategorias] = useState([]);
    const [materiales,setMateriales]=useState([]);
    const [bod,setBod]=useState([]);
    const [carritoMat,setCarritoMat]=useState([]);
    const [fecha, setFecha] = useState();
    const [nota, setNota] = useState();
    const [catId, setCatId] = useState(resIdCat);
    const [catNom, setCatNom] = useState(resNomCat);
    const [tablaMateriales,setTablaMateriales]=useState([]);
    const [busquedaM,setBusquedaM] = useState ('');
    let suma=0;
    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => {
        setShowAdd(false);
        setBodega('');
        setCarritoMat([]);
        setFecha();
        setNota();
        setCatId();
        setCatNom('CATEGORIA');
    }
    const handleShowAdd = async () =>{
        await getAllCategorias();
        await getMateriales();
        await getBodegas();
        setShowAdd(true);
    }
    const buscarM = e => {
        setBusquedaM(e.target.value)
        filtrarM(e.target.value)
    }
    const filtrarM = (textoIngresado) =>{
        var resultadoBusqueda = tablaMateriales.filter((elemento)=> {
            if(elemento.nombreMat.toString().toLowerCase().includes(textoIngresado.toLowerCase())){
                return elemento;
            }
        return resultadoBusqueda;
        });
        setMateriales(resultadoBusqueda);
    }
    const getAllCategorias = async () =>{
        const endpoint = 'catmat/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setCategorias(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const getMateriales = async () =>{
        const endpoint = 'mat/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setMateriales(res.data);
                setTablaMateriales(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const getBodegas = async () =>{
        const endpoint = 'bodegas/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setBod(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const getFecha = () =>{
        const date= moment (new Date());
        return(date.tz('America/Mexico_City').format('YYYY-MM-DD'))
    }
    const handleHer = ( catId, catNom) =>{
        sessionStorage.setItem("idCM",catId)
        sessionStorage.setItem("nomCM",catNom)
        const resId =  parseInt(sessionStorage.getItem("idCM"))
        const resNom =  sessionStorage.getItem("nomCM")
        setCatId(resId)
        setCatNom(resNom)
    }
    const handleSelectChange2 = (event) =>{
        console.log("bodega "+event.value)
        setBodega(event.value)
    }
    const agregarCarrito =(idMat,nombre)=>{
        var cantidad = parseFloat(document.getElementById(`m${idMat}`).value)
        var precio = parseFloat(document.getElementById(`d${idMat}`).value)
        if(document.getElementById(`m${idMat}`).value==='' || document.getElementById(`d${idMat}`).value===''){
            warningToast('¡ERROR!','CAMPOS VACIOS...');
        }else{
            if(cantidad<=0 || precio<=0){
                warningToast('¡ERROR!','LA CANTIDAD INGRESADA DEBE SER MAYOR A 0...');
            }else{
                const newMat = {
                    precio:precio,
                    cantidad:cantidad,
                    material:idMat,
                    nombre:nombre
                }
                setCarritoMat([...carritoMat,newMat])
                var input = document.getElementById(`m${idMat}`);
                input.value = null
                var input2 = document.getElementById(`d${idMat}`);
                input2.value = null
            }
        }
    }
    const totalMat=(lista)=>{
        for (var j = 0; j < lista.length; j++){
            suma+= parseFloat(lista[j].cantidad*lista[j].precio)
        }
        return suma;
    }
    const eliminarCarrito =(id)=>{
        const deleteCarrito = carritoMat.filter((material)=>
        material.material !== id);
        setCarritoMat(deleteCarrito);
    }
    const cancelar = async () => {
        if(carritoMat.length === 0 ){
            handleCloseAdd();
        }else{
            warningToast('¿SEGURO QUE QUIERES SALIR?',"UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS",true)
            .then((result) => {
                if (result.isConfirmed) {
                    handleCloseAdd();
                }
            })   
        } 
    }
    const agregarEntrada = async () =>{
        if(bodega===''){
            warningToast('¡ERROR!','FALTA SELECCIONAR UNA BODEGA...');
        }else if (fecha===undefined){
            warningToast('¡ERROR!','FALTA SELECCIONAR UNA FECHA...');
        }else if (nota===undefined){
            warningToast('¡ERROR!','FALTA AGREGAR NÚMERO DE NOTA...');
        }else{
            setSaving(true);
            const  arregloJson = JSON.stringify(carritoMat)
            const endpoint = 'entradas/';
            const data = {listaCarrito:arregloJson,idObra:numObra,bodega:bodega,fecha:fecha,nota:nota,idU:"sistema"};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="Registro creado correctamente"){
                    handleCloseAdd();
                    getEntradas();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
            setSaving(false);
        }
    }
    /*AGREGAR MATERIALES FIN*/

    return (
        <div className='herramientas' >
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">ENTRADA DE MATERIALES A OBRA</label>
                    </div>
                    <div>
                        <h4 className='text-uppercase'>{nombreObra}</h4>
                    </div>
                    <ModalAgregarAlmacen />
                    <div className='divboton' >                                                                                             
                        <div className='boton'  style={{display:'flex', justifyContent:'space-between'}}>
                            <button style={{justifyContent:'center'}}  className="btn btn-light btncolor" onClick={handleShowAdd} type="button">
                                <label className="agregar">ENTRADA ALMACEN</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control " value={busqueda} onChange={buscar}  style={{width:'50%'}} type="search" placeholder="Material-Fecha" aria-label="Search"/> 
                        </div>
                    </div>  
                    <div style={{display:'flex', justifyContent:'space-between',marginBottom:"10px"}}>
                        <div  >
                            <div>Entrada</div>
                            <div  className='colorAzul' ></div>
                        </div> 
                        <div  >
                            <div>Préstamo</div>
                            <div  className='colorAmarillo' ></div>
                        </div>
                        <div>
                            <div>Devolución</div>
                            <div  className='colorVerde' ></div>
                        </div>
                    </div>
                    {
                        entradas.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):
                        <div className="caja-asistencia" >
                            <div className="table tabla">
                                <table className="table table-hover table-bordered text-uppercase">
                                    <thead className="encabezado">
                                        <tr >
                                            <th> CANTIDAD </th>
                                            <th>PRECIO</th>
                                            <th> MATERIAL </th>
                                            <th> FECHA </th>
                                            <th> BODEGA </th>
                                            <th> NOTA </th>
                                            <th> ELIMINAR </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {entradas.map(dato => {
                                            return (
                                                <tr style={{ backgroundColor: getColor(dato.estadoEntrada) }} key={dato.idEntMat}>
                                                    <td valign="middle" className="text-uppercase">{dato.cantEntMat}</td>
                                                    <td valign="middle" className="text-uppercase">${formato(dato.precioUni)}</td>
                                                    <td valign="middle" className="text-uppercase">{dato.nombreMat}</td>
                                                    <td valign="middle" className="text-uppercase">{moment(dato.fechaEntMat).format("DD-MM-YYYY")}</td>
                                                    <td valign="middle" className="text-uppercase">{dato.nombreBod}</td>
                                                    <td valign="middle">{dato.nota}</td>
                                                    <td>
                                                        <div className="btn iconoH" style={{margin:'5px'}} onClick={() => eliminar(dato.idEntMat)}>
                                                            <span className="bi bi-trash" title="ELIMINAR"></span>
                                                        </div> 
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }

                    {/*AGREGAR MATERIALES*/}     
                    <Modal  show={showAdd}  onHide={handleCloseAdd} fullscreen={true} id="modal-agregar-materiales"  backdrop="static" keyboard={false}>
                        <Modal.Header className=' btncolor' style={{textAlign:"center"}}>
                            <Modal.Title>ENTRADA DE MATERIALES A OBRA</Modal.Title>
                            <CloseButton onClick={cancelar} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left',height:'60vh', overflowY:"scroll" }}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <div className="mb-3" style={{textAlign:'center'}}>
                                <h5 className="modal-title text-uppercase " id="exampleModalLabel">{nombreObra}</h5>
                            </div>
                            <div className='row' style={{justifyContent:"center"}}>
                                <div className='col-md-3'>
                                    <label htmlFor="exampleFormControlInput1" className="form-label">CATEGORIA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <div className="dropdown" >
                                        {
                                            catNom === null ? (
                                            <button className="btn btn-secondary dropdown-toggle text-uppercase" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            CATEGORIA
                                            </button>):( <button className="btn btn-secondary dropdown-toggle text-uppercase" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {catNom}
                                            </button>)
                                        }
                                        <ul className="dropdown-menu">
                                            {categorias.map(categoria =>{
                                                return(
                                                    <li key={categoria.idCatMat} >
                                                        <button className="dropdown-item text-uppercase" onClick={()=> handleHer(categoria.idCatMat,categoria.nombreCatMat)} >
                                                            {categoria.nombreCatMat}
                                                        </button>
                                                    </li>
                                                )
                                            })}                                   
                                        </ul>
                                    </div>  
                                </div>
                                <div className='col-md-3'>
                                    <div >
                                        <label htmlFor="exampleFormControlInput1" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                        <input type="date" className="form-control" max={getFecha()} onChange={e => setFecha(e.target.value) } id="exampleFormControlInput1" required/>
                                    </div>
                                </div>
                                <div className='col-md-3'>      
                                    <div className="text-uppercase"  style={{marginTop:"8px"}}>
                                        <label htmlFor="exampleFormControlInput1" > bodega <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                        <Select
                                            classNamePrefix="select"
                                            placeholder="Seleccionar..."
                                            required
                                            options={bod.map(tip=>({label:tip.nombreBod,value:tip.idBodega}))}
                                            onChange={handleSelectChange2}
                                        />
                                    </div>
                                </div>
                                <div className='col-md-3'>      
                                    <div className="text-uppercase"  style={{marginTop:"8px"}}>
                                        <label htmlFor="exampleFormControlInput1" > NO. NOTA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                        <input type="text" className="form-control"  onChange={e => setNota(e.target.value)} id="exampleFormControlInput1" required/>
                                    </div>
                                </div>
                            </div>
                            <div style={{width:'100%'}}>
                                <input type="search" placeholder="Nombre del material" value={busquedaM} onChange={buscarM} className="form-control buscarMat" aria-describedby="basic-addon1"/>                                     
                                <div className='lista1' >
                                    <div className="table-responsive text-uppercase" style={{marginRight:"10px",textAlign:"center"}}>
                                        <table className="table">
                                            <thead >
                                                <tr>
                                                    <th >MATERIAL</th>
                                                    <th >CANTIDAD</th>
                                                    <th >PRECIO(UNIDAD)</th>
                                                    <th>AGREGAR</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                                { materiales.map( entrada => {
                                                    return (
                                                        entrada.idCatMat === catId ? (
                                                            <tr key={entrada.idMaterial}>
                                                                <td>{entrada.nombreMat}</td>
                                                                <td>
                                                                    <form> <input required id={`m${entrada.idMaterial}`} style={{width:"50px"}}  > 
                                                                    </input> 
                                                                    </form>
                                                                </td> 
                                                                <td>
                                                                    <form> <input required id={`d${entrada.idMaterial}`} style={{width:"50px"}}  > 
                                                                    </input> 
                                                                    </form>
                                                                </td>
                                                                <td>
                                                                    <button  className="btn  btncolor" style={{width:"40px",padding:"5px"}} type="button"  onClick={() => agregarCarrito(entrada.idMaterial,entrada.nombreMat)}>
                                                                    <BsPlus  style={{fontSize:'30px'}}/>    
                                                                    </button>
                                                                </td>                                     
                                                            </tr>
                                                        ):(null)
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div style={{justifyContent:"space-between",display:"flex"}}>
                                    <b style={{marginRight:"15px",marginLeft:"15px"}}>AGREGADOS</b>
                                    <b style={{marginRight:"15px",marginLeft:"15px"}}>{'TOTAL: $ '+formato(totalMat(carritoMat))}</b>
                                </div>
                                <div className='lista2' >
                                    <div className="table-responsive text-uppercase" style={{backgroundColor:'#efefef', borderRadius:'15px'}}>
                                        {
                                            carritoMat.length === 0  ?(<div><p>VACIO</p></div>):(
                                            <table className="table" >
                                                <thead >
                                                    <tr>
                                                        <th >MATERIAL</th>
                                                        <th >CANTIDAD</th>
                                                        <th >PRECIO(UNIDAD)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    { carritoMat.map( tipo => {
                                                        return (
                                                            <tr key={tipo.material}>
                                                                <td>{tipo.nombre}</td>
                                                                <td>{tipo.cantidad}</td>
                                                                <td>${tipo.precio}</td>
                                                                <td>
                                                                    <div>
                                                                        <div className="btn iconoH"  onClick={() => eliminarCarrito(tipo.material)} style={{color:'red', cursor:'pointer'}}>
                                                                            <span className="bi bi-trash" title="ELIMINAR"></span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )})
                                                    }
                                                </tbody>
                                            </table>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary"  onClick={cancelar} >CANCELAR</Button>
                            {
                                carritoMat.length === 0 ? (
                                    <Button type="button" className="btn btncolor" disabled >ACEPTAR</Button>
                                ):(
                                    isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="button" className="btn btn-light btncolor" onClick={agregarEntrada} >ACEPTAR</Button>
                                )
                            }                                        
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default TablaEntrada;